import { ReduceStore } from "flux/utils";
import Dispatcher from "../Dispatcher";
import LoadObject from "./LoadObject";
import LoadObjectState from "./LoadObjectState";
import ExportParamActions from "./ExportParamActions";
import DataManager from "./DataManager";
import userStore from "./userStore";
import { OPT_USER_CONFIRMED } from "./RecordActions";

class ExportParamsStore extends ReduceStore {

    getInitialState() {
        return new LoadObjectState(
            () => this.__dispatcher.dispatch({
                type: ExportParamActions.START_LOAD,
            }),
        );
    }

    reduce(state, action) {
        switch (action.type) {
            case ExportParamActions.START_LOAD: {
                DataManager.loadExportParams(userStore.getActiveOrgKey());
                return state.setLoadObject(LoadObject.loading());
            }

            case ExportParamActions.LOADED: {
                return state.setLoadObject(LoadObject.withValue(action.data));
            }

            case ExportParamActions.LOAD_ERROR: {
                return state.setLoadObject(LoadObject.withError(action.error));
            }

            case ExportParamActions.INVALIDATE_CACHE: {
                return state.setLoadObject(LoadObject.empty());
            }

            case ExportParamActions.CREATE: {
                if (!action.name) return state;
                DataManager.createExportParams(
                    userStore.getActiveOrgKey(),
                    {
                        name: action.name,
                        typeKey: action.formKey,
                        params: action.params,
                    },
                );
                return state.mapLO(lo => lo.creating());
            }

            case ExportParamActions.UPDATE: {
                DataManager.updateExportParams(
                    userStore.getActiveOrgKey(),
                    {
                        id: action.id,
                        params: action.params,
                    },
                );
                return state.mapLO(lo => lo.updating());
            }

            case ExportParamActions.RENAME: {
                if (!action.name) return state;
                DataManager.updateExportParams(
                    userStore.getActiveOrgKey(),
                    {
                        id: action.id,
                        name: action.name,
                    },
                );
                return state.mapLO(lo => lo.updating());
            }

            case ExportParamActions.DELETE: {
                if (!action[OPT_USER_CONFIRMED]) return state;
                DataManager.deleteExportParams(
                    userStore.getActiveOrgKey(),
                    action.id,
                );
                return state.mapLO(lo => lo.deleting());
            }

            case ExportParamActions.CREATED: {
                return state.mapLO(lo => lo.done()
                    .map(value => value.concat(action.data)));
            }

            case ExportParamActions.UPDATED:
            case ExportParamActions.RENAMED: {
                return state.mapLO(lo => lo.done()
                    .map(value => value.map(s =>
                        s.id === action.data.id ? action.data : s)));
            }

            case ExportParamActions.DELETED: {
                return state.mapLO(lo => lo.done()
                    .map(value => value.filter(s => s.id !== action.data.id)));
            }

            case ExportParamActions.CREATE_ERROR:
            case ExportParamActions.UPDATE_ERROR:
            case ExportParamActions.RENAME_ERROR:
            case ExportParamActions.DELETE_ERROR: {
                return state.mapLO(lo => lo.done().setError(action.error));
            }

            default:
                return state;
        }
    }

    getLoadObject() {
        return this.getState().getLoadObject();
    }

}

export default new ExportParamsStore(Dispatcher);



// WEBPACK FOOTER //
// ./app/data/exportParamsStore.js